import {h} from 'preact';
import * as styles from './audio-icon.scss';

const AudioIcon = ({isActive}: {isActive: boolean}) => {
  return (
    <div data-testid={`aad-playback-icon${isActive ? '-active' : ''}`} className={[styles.audioIcon, isActive ? styles.active : ''].join(' ')}>
      <div className={styles.box2} />
      <div className={styles.box1} />
      <div className={styles.box2} />
    </div>
  );
};

export {AudioIcon};
